/*
 * Site JavaScript entry point.
 *
 * Add imports here to organize your code. esbuild will bundle everything
 * into js/bundle.js.
 */
import { BLOKCustomElements } from "@brutrb/blok";

BLOKCustomElements.defineAll();
